import { createReducer } from '../../../../helpers/reducer';
import actions from './actions';
import { ILegalEntitiesListLoadSuccessPayload } from './actions.types';
import { ILegalEntitiesListState } from './reducer.types';

const initState: ILegalEntitiesListState = {
  records: null,
  total: 0,
  filteredTotal: 0,
  sortableColumns: [],
  loading: false,
};

function onLoadRequest(state: ILegalEntitiesListState) {
  return { ...state, loading: true };
}

function onLoadSuccess(state: ILegalEntitiesListState, { payload }: { payload: ILegalEntitiesListLoadSuccessPayload }) {
  return {
    ...state,
    loading: false,
    records: payload.records,
    total: payload.total,
    filteredTotal: payload.filteredTotal,
    sortableColumns: payload.sortableColumns ?? [],
  };
}

function onLoadError(state: ILegalEntitiesListState) {
  return { ...state, loading: false };
}

function onClearStore() {
  return { ...initState };
}

export default createReducer(initState, {
  [actions.LOAD_REQUEST]: onLoadRequest,
  [actions.LOAD_SUCCESS]: onLoadSuccess,
  [actions.LOAD_ERROR]: onLoadError,
  [actions.CLEAR_STORE]: onClearStore,
});
